import { FundViewOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { LoginPage } from '../pages/login';
import { useAuthContext } from '../services/auth.service';
import './layout.scss';
import { BurgerMenu } from './burgerMenu';

/* -------------------------------------------------------------------------------- *\
|                               LayoutSite
\* -------------------------------------------------------------------------------- */
export const LayoutSite: FC<{ children?: ReactNode }> = (children) =>
{
	const [isBurgerMenuVisible, setIsBurgerMenuVisible] = useState<boolean>(false);
	const [scrollDirection, setScrollDirection] = useState<string | null>(null);
	const lastScrollY = useRef(0);
	const THRESHOLD = 100;
  
	useEffect(() => {
		const handleScroll = () => {
		  const currentScrollY = window.scrollY;

		  if (currentScrollY === 0) {
			setScrollDirection('up');
		  } else if (currentScrollY < THRESHOLD) {
			setScrollDirection('up');
		  } else if (currentScrollY > lastScrollY.current) {
			setScrollDirection('down');
		  }

		  lastScrollY.current = currentScrollY;
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => window.removeEventListener('scroll', handleScroll);
	  }, []);

	var auth = useAuthContext();
	if (!auth || !auth.token)
	{
		return <LoginPage />
	}

	return (
		<div className="layout">
			<div className="layout__sider" >
				<div className="layout__logo">
					<img src={'/images/logo.png'} alt="McLloyd" />
				</div> 
				<div className="layout__menucont">
					<div className="layout__menu">
						{/* <a className='layout__menu__item' href="/" ><CalendarOutlined /></a> */}
						<a className='layout__menu__item' href="/" ><FundViewOutlined /></a>
						{auth.isAdmin && <a className='layout__menu__item' href="/admin"><SettingOutlined /></a>}
					</div>
					<div className="layout__menu layout__menu__bottom">
						<div className='layout__menu__item' onClick={() => auth.logout()}><LogoutOutlined /></div>
					</div>
				</div>
			</div>
			<div className={`layout__content ${scrollDirection === 'down' ? 'layout__content__down' : ''} ${scrollDirection === 'up' ? 'layout__content__up' : ''}`}>
				<div className="layout__content__inner">
					<BurgerMenu isBurgerMenuVisible={isBurgerMenuVisible} setIsBurgerMenuVisible={setIsBurgerMenuVisible} />
					<div>{children.children}</div>
					<div className="layout__footer">version 2.0.4</div>
				</div>
			</div>
	  </div>
	  );
}